import { Briefcase, Gift, HeartHandshake, Sparkles, Trophy, Coins, type LucideIcon } from "lucide-react";

/**
 * Single source of truth for how Sim Wallet transaction types are labeled
 * and grouped in UI. Career paycheck remains its own bucket; allowance,
 * gifts, parent bonuses, and module rewards are grouped as "other income".
 */

export type IncomeBucket = "career" | "other" | "quiz" | "system";

export interface IncomeCategoryMeta {
  label: string;
  bucket: IncomeBucket;
  icon: LucideIcon;
}

export const OTHER_INCOME_TYPES = [
  "allowance",
  "gift",
  "parent_bonus",
  "module_reward",
] as const;

export type OtherIncomeType = (typeof OTHER_INCOME_TYPES)[number];

export const INCOME_CATEGORIES: Record<string, IncomeCategoryMeta> = {
  allowance: { label: "Allowance", bucket: "other", icon: Coins },
  gift: { label: "Gift", bucket: "other", icon: Gift },
  parent_bonus: { label: "Parent Bonus", bucket: "other", icon: HeartHandshake },
  module_reward: { label: "HeirWise Reward", bucket: "other", icon: Trophy },
  quiz_reward: { label: "Quiz Reward", bucket: "quiz", icon: Sparkles },
  completion_bonus: { label: "Completion Bonus", bucket: "quiz", icon: Sparkles },
  career_paycheck: { label: "Career Paycheck", bucket: "career", icon: Briefcase },
};

export function categoryFor(type: string | null | undefined): IncomeCategoryMeta {
  if (type && INCOME_CATEGORIES[type]) return INCOME_CATEGORIES[type];
  return { label: "Deposit", bucket: "system", icon: Sparkles };
}

export function isOtherIncomeType(type: string | null | undefined): type is OtherIncomeType {
  return !!type && (OTHER_INCOME_TYPES as readonly string[]).includes(type);
}